'use client';

import { useState, useEffect } from 'react';

export function useMediaQuery(query: string): boolean {
  // Always initialize with false to match server-side rendering
  // This prevents hydration mismatches
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    // Check if we're in a browser environment
    if (typeof window === 'undefined') return;

    const mediaQueryList = window.matchMedia(query);

    // Set initial value after hydration
    setMatches(mediaQueryList.matches);

    const listener = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    // Older browsers might need addListener
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener('change', listener);
    }

    // Clean up on unmount
    return () => {
      if (mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener('change', listener);
      }
    };
  }, [query]);

  return matches;
}
